import { Navigate, useLocation } from "react-router-dom";
import { Center, Spinner } from "@chakra-ui/react";
import { useAuth } from "../../features/auth/hooks/useAuth";

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, isLoadingMe } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/auth/login" replace state={{ from: location }} />;
  }

  if (isLoadingMe) {
    return (
      <Center minH="100vh">
        <Spinner color="primary" size="lg" />
      </Center>
    );
  }

  return children;
}
